// extracted by mini-css-extract-plugin
export var closeButton = "_b-3";
export var header = "_b-0";
export var link = "_b-1";
export var retryButton = "_b-2";